import React from "react";

import styles from "./TemplateLocal.module.css";
import PropTypes from "prop-types";
import { endOfMonth, format, startOfMonth } from "date-fns";
import ImageWithBasePath from "core/img/imagewithbasebath";

const LocalPayslip = ({ payrollDetails, companyDetails }) => {
  const additionRows = payrollDetails?.additionsList?.length + 1;
  const deductionRows = payrollDetails?.deductionsList?.length || 0;

  return (
    <div className={`mb-5 ${styles.payslip}`}>
      <div className={styles.header}>
        {/* <ImageWithBasePath src="assets/img/logo.png" alt="Logo" /> */}
        <img
          src={`data:image/png;base64,${companyDetails?.companyLogo}`}
          alt="Compnay Logo"
          style={{ width: "110px" }}
        />
        <div className={styles["header-text"]}>
          <h2 className="mb-2">{companyDetails?.companyName.toUpperCase()}</h2>
          <h6>
            {companyDetails?.address1}
            {companyDetails?.address2}
            {companyDetails?.address3}
            {companyDetails?.country} - {companyDetails?.zipCode}
          </h6>
          <h6>
            Ph : {companyDetails?.phoneNo} | Email : {companyDetails?.email}
          </h6>
        </div>
      </div>
      <table className={`${styles.details}`}>
        <tr>
          <td>Employee Name</td>
          <td>{payrollDetails?.fullName}</td>
          <td>Pay Period Begin Date</td>
          <td>{format(new Date(payrollDetails?.fromDate), "dd-MM-yyyy")}</td>
        </tr>

        <tr>
          <td>Employee ID</td>
          <td>{payrollDetails?.uniqueID}</td>
          <td>Pay Period End Date</td>
          <td>{format(new Date(payrollDetails?.toDate), "dd-MM-yyyy")}</td>
        </tr>

        <tr>
          <td>IC No / FIN No</td>
          <td>
            {payrollDetails?.residentialType === "OS"
              ? payrollDetails?.finNumber
              : payrollDetails?.icno}
          </td>
          <td>Pay Date</td>
          <td>{format(new Date(payrollDetails?.paymentDate), "dd-MM-yyyy")}</td>
        </tr>
        <tr>
          <td>DOB / Age</td>
          <td>{payrollDetails?.hpno}</td>
          <td>Date of Joining</td>
          <td>
            {payrollDetails?.joinDate !== "" &&
              format(new Date(payrollDetails?.joinDate), "dd-MM-yyyy")}
          </td>
        </tr>
        <tr>
          <td>Job Title</td>
          <td>{payrollDetails?.jobTitle}</td>
          <td></td>
          <td></td>
        </tr>
      </table>

      <div className={styles["wrapper"]}>
        <div className={styles["table-container"]}>
          <table className={`${styles.details2}`}>
            <tr>
              <th className={`${styles["table-header"]} mb-2`} colSpan={2}>
                <h4 style={{ marginBottom: "0px" }}>Earning (SGD)</h4>
              </th>
            </tr>

            {payrollDetails?.earningsList.map(
              (pd, _k) =>
                Number(pd?.amount) !== Number(0) && (
                  <tr key={_k}>
                    <td className={styles.label}>{pd?.description}</td>
                    <td className={styles.value}>
                      {Number(pd?.amount).toFixed(2)}
                    </td>
                  </tr>
                )
            )}
          </table>
          {/* {payrollDetails?.earningsList.map(
            (pd, _k) =>
              pd?.amount > 0 && (
                <div className={styles.payrollListRow} key={_k}>
                  <span className={styles.label}>{pd?.description}</span>
                  <span className={styles.value}>
                    {Number(pd?.amount).toFixed(2)}
                  </span>
                </div>
              )
          )} */}
          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Earning</span>
              <span className={styles.value}>
                {Number(payrollDetails?.totalEarning).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>
                <strong>Employer Contribution</strong>
              </span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>CPF</span>
              <span className={styles.value}>
                {Number(payrollDetails?.employerCpf).toFixed(2)}
              </span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>FWL</span>
              <span className={styles.value}>0.00</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>SDL</span>
              <span className={styles.value}>
                {Number(payrollDetails?.sdlAmount).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className={styles["table-container"]}>
          <table className={`${styles.details2}`}>
            <tr>
              <th className={`${styles["table-header"]} mb-2`} colSpan={2}>
                <h4 style={{ marginBottom: "0px" }}>Deductions (SGD)</h4>
              </th>
            </tr>

            {payrollDetails?.deductionsList.map(
              (pd, _k) =>
                Number(pd?.amount) !== Number(0) && (
                  <tr key={_k}>
                    <td className={styles.label}>{pd?.description}</td>
                    <td className={styles.value}>
                      {Number(pd?.amount).toFixed(2)}
                    </td>
                  </tr>
                )
            )}
          </table>

          {/* <div className={`${styles["table-header"]} mb-2`}>
            <h4>Deductions (SGD)</h4>
          </div>
          {payrollDetails?.deductionsList.map(
            (pd, _k) =>
              pd?.amount > 0 && (
                <div className={styles.payrollListRow} key={_k}>
                  <span className={styles.label}>{pd?.description}</span>
                  <span className={styles.value}>
                    {Number(pd?.amount).toFixed(2)}
                  </span>
                </div>
              )
          )} */}

          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Deduction</span>
              <span className={styles.value}>
                {Number(payrollDetails?.totalDeduction).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>
                <strong>Payment Information</strong>
              </span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Payment Mode</span>
              <span className={styles.value}>
                {payrollDetails?.paymentMode}
              </span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Reference Number</span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>&nbsp;</span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>Net Salary</span>
              <span>{payrollDetails?.netPay}</span>
            </div> */}
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>YTD Employee Salary</span>
              <span>695.90</span>
            </div> */}
          </div>
        </div>
      </div>

      {/* <div className={styles["table-container"]}> */}
      <div className="">
        <div
          className={styles.payrollListRow}
          style={{ justifyContent: "end" }}
        >
          <strong>
            <span className={styles.label}> Basic Pay</span>
            &nbsp;&nbsp;
            <span className={styles.value}>
              {Number(payrollDetails?.grossSalary).toFixed(2)}
            </span>
          </strong>
        </div>
        <div
          className={styles.payrollListRow}
          style={{ justifyContent: "end" }}
        >
          <strong>
            <span className={styles.label}> Net Pay</span>
            &nbsp;&nbsp;
            <span className={styles.value}>
              {Number(payrollDetails?.netPay).toFixed(2)}
            </span>
          </strong>
        </div>
      </div>

      {/* <div className={styles.signatureSection}>
        <div className={styles.label}>
          Prepared By : {payrollDetails?.reviewedBy}
        </div>
        <div className={styles.label}>
          Approved By : {payrollDetails?.approvedBy}
        </div>
        <div className={styles.label}>
          Received By : {payrollDetails?.preparedBy}
        </div>
      </div> */}

      <div className={styles["bottom-text"]}>
        <p className="text-center">
          This is computer generated payslip, No Signature is required.
        </p>
      </div>
    </div>
  );
};
LocalPayslip.propTypes = {
  payrollDetails: PropTypes.array.isRequired,
  companyDetails: PropTypes.object.isRequired,
};
export default LocalPayslip;
